import callbackResize from "./callback-resize";

/**
 *
 * @param {WindowObserverProps} observers
 */
const onResizeMutation = (observers) => {
  /** Set new `ResizeObserver` to the map */
  observers.set("resize", new ResizeObserver(callbackResize));

  /** Set type */
  const resize = /** @type {ResizeObserver} */ (observers.get("resize"));

  /** Initialize the observer with options */
  resize.observe(document.body);
};

export default onResizeMutation;
